import { Link as ReactLink, LinkProps as ReactLinkProps } from 'react-router-dom'
import { useMouseDrag } from 'hooks'

type LinkProps = ReactLinkProps & {
  disabled?: boolean
  dataTest?: string
}

const Link: React.FC<LinkProps> = props => {
  const { onClick, to, disabled, children, dataTest, ...rest } = props
  const isMouseDraged = useMouseDrag()

  function handleClick(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
    if (isMouseDraged) e.preventDefault()
    if (onClick) onClick(e)
  }

  return disabled ? (
    <>{children}</>
  ) : (
    <ReactLink onClick={handleClick} to={to} children={children} data-test={dataTest} {...rest} />
  )
}

export default Link
